import { useWorkspace } from "@/contexts/WorkspaceContext";
import { useTranslation } from "react-i18next";
import { Loader2, Building2 } from "lucide-react";

export function WorkspaceSwitchingOverlay() {
  const { isSwitching, switchingToName } = useWorkspace();
  const { t } = useTranslation();

  if (!isSwitching) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-background/80 backdrop-blur-sm animate-fade-in">
      <div className="flex flex-col items-center gap-4 rounded-2xl border border-border bg-card p-8 shadow-lg max-w-sm text-center">
        <div className="rounded-full bg-primary/10 p-3">
          <Building2 className="h-8 w-8 text-primary" />
        </div>
        <div className="space-y-1.5">
          <h3 className="text-lg font-semibold text-foreground">
            {t("workspace.switching", "Switching workspace...")}
          </h3>
          {switchingToName && (
            <p className="text-sm text-muted-foreground">
              {t("workspace.switchingTo", "Loading data for {{name}}", { name: switchingToName })}
            </p>
          )}
        </div>
        <Loader2 className="h-6 w-6 animate-spin text-primary" />
      </div>
    </div>
  );
}
